"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldEditorSubForm = void 0;
const tslib_1 = require("tslib");
const core_shared_1 = require("@ikegps/core-shared");
const form_palette_1 = require("../form.palette");
const form_field_editor_1 = require("./form.field.editor");
const form_field_tree_view_1 = require("./form.field.tree.view");
const mithril_1 = require("../../../mithril");
const input_select_1 = require("../../../components/input/input.select");
const mobx_1 = require("mobx");
const i18n_1 = require("../../../i18n");
const core_api_1 = require("@ikegps/core-api");
class FormFieldEditorSubForm extends form_field_editor_1.FormFieldEditor {
    constructor(designer, field) {
        super(designer, field);
        this.subFormTypeSelectState = this.initialSubFormTypeSelectState();
        this.spanVectorFieldSelectState = this.initialSpanVectorFieldSelectState();
        this.spanTypeFieldSelectState = this.initialSpanTypeFieldSelectState();
        this.state.reaction(() => this.subFormTypeSelectState.value &&
            this.spanVectorFieldSelectState.value &&
            this.spanTypeFieldSelectState.value, () => this.updateSubFormType());
        // Only require Span field selections if SubForm type is Span.
        this.subFormTypeSelectState.onValue((value) => {
            if (value === core_api_1.SubFormType.SPAN) {
                this.spanVectorFieldSelectState.isRequired = true;
                this.spanTypeFieldSelectState.isRequired = true;
            }
            else {
                this.spanVectorFieldSelectState.isRequired = false;
                this.spanTypeFieldSelectState.isRequired = false;
            }
        });
    }
    initialSubFormTypeSelectState() {
        const options = [];
        if (this.canBeSpan()) {
            options.push({ key: 'Span', value: core_api_1.SubFormType.SPAN });
        }
        const state = new input_select_1.SelectInputState((0, i18n_1.Translate)(i18n_1.T.TYPE), options);
        state.placeholder = (0, i18n_1.Translate)(i18n_1.T.NONE);
        state.setValue(this.field.subFormType);
        state.setDisabled(true);
        this.state.add(state);
        state.isLabelShown = true;
        return state;
    }
    canBeSpan() {
        return this.field.fields.some(core_shared_1.isValidSpanVectorField) && this.field.fields.some(core_shared_1.isValidSpanTypeField);
    }
    initialSpanVectorFieldSelectState() {
        var _a, _b;
        const state = new input_select_1.SelectInputState((0, i18n_1.Translate)(i18n_1.T.SPAN_VECTOR_FIELD), this.field.fields.filter(core_shared_1.isValidSpanVectorField).map((field) => ({ key: field.displayName, value: field.id })));
        state.setValue((_b = (_a = this.field.subFormSpanTypeState) === null || _a === void 0 ? void 0 : _a.vectorFieldId) !== null && _b !== void 0 ? _b : null);
        state.setDisabled(true);
        this.state.add(state);
        state.isLabelShown = true;
        return state;
    }
    initialSpanTypeFieldSelectState() {
        var _a, _b;
        const state = new input_select_1.SelectInputState((0, i18n_1.Translate)(i18n_1.T.SPAN_TYPE_FIELD), this.field.fields.filter(core_shared_1.isValidSpanTypeField).map((field) => ({ key: field.displayName, value: field.id })));
        state.setValue((_b = (_a = this.field.subFormSpanTypeState) === null || _a === void 0 ? void 0 : _a.typeFieldId) !== null && _b !== void 0 ? _b : null);
        state.setDisabled(true);
        this.state.add(state);
        state.isLabelShown = true;
        return state;
    }
    /**
     * If Span type and both field references are selected in the UI, then set the subform type to SPAN.
     * Otherwise, clear the subform type.
     */
    updateSubFormType() {
        if (!this.subFormTypeSelectState.value) {
            this.field.Mutator.clearType();
            return;
        }
        if (!this.spanVectorFieldSelectState.value || !this.spanTypeFieldSelectState.value) {
            this.field.Mutator.clearType();
            return;
        }
        this.field.Mutator.spanTypeWithFields(this.spanVectorFieldSelectState.value, this.spanTypeFieldSelectState.value);
    }
    viewTree() {
        return form_field_tree_view_1.FormFieldTreeView.viewForm(this);
    }
    viewInfoRW() {
        return (0, mithril_1.m)('div', {}, [
            this.viewSubFormTypeEditor(),
            form_palette_1.FormDesignerPalette.view((type) => this.designer.createField(this.field, type), this.depth),
        ]);
    }
    viewSubFormTypeEditor() {
        // If there are no valid subform types, don't display the type selector at all.
        if (!this.canBeSpan()) {
            return null;
        }
        return (0, mithril_1.m)('div', { style: { 'margin-bottom': '32px' } }, [
            input_select_1.SelectInputComponent.view(this.subFormTypeSelectState),
            ...(this.subFormTypeSelectState.value === core_api_1.SubFormType.SPAN
                ? [
                    input_select_1.SelectInputComponent.view(this.spanVectorFieldSelectState),
                    input_select_1.SelectInputComponent.view(this.spanTypeFieldSelectState),
                ]
                : []),
        ]);
    }
}
exports.FormFieldEditorSubForm = FormFieldEditorSubForm;
tslib_1.__decorate([
    mobx_1.action
], FormFieldEditorSubForm.prototype, "updateSubFormType", null);
//# sourceMappingURL=form.field.editor.subform.js.map